import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfigDto } from 'src/app/shared/interfaces/config';
import { ConfigService } from 'src/app/shared/services/config.service';
@Component({
  selector: 'app-file-choice-modal',
  templateUrl: './file-choice-modal.component.html',
  styleUrls: ['./file-choice-modal.component.scss'],
})
export class FileChoiceModalComponent implements OnInit {
  public canCreateEmail = true;
  public appConfig: ConfigDto = null;
  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.configService.fetchConfig().subscribe({
      next: (res: ConfigDto) => {
        this.appConfig = res;
      },
    });
  }

  public close(result: string): void {
    this.ref.close(result);
  }
}
